export default __webpack_public_path__ + "static/media/I0001.ffa6e2fe.png";